import { Container, Drawer } from '@mui/material';
const ProjectDrawer = (props) => {
  const { openDrawer, handleCloseDrawer, contentComponent } = props;

  return (
    <>
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={handleCloseDrawer}
        slotProps={{
          paper: {
            sx: { width: 'auto', paddingTop: 3 },
          },
        }}
      >
        <Container>{contentComponent}</Container>
      </Drawer>
    </>
  );
};

export default ProjectDrawer;
